// extracted by mini-css-extract-plugin
export default {"noDataWrapper":"noDataWrapper-c_iQa","noData":"noData-Q_3LE"};